import { Route, useHistory, useLocation } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import { SecureRoute } from '@okta/okta-react';
import { useLayoutEffect } from 'react';
import useSWR from 'swr';
import { getTenantName } from 'packages/lib/auth';
import { isContractorPath, isMobisPath } from 'packages/lib/auth/is-path';

const OktaRoute: typeof SecureRoute = (props) => {
  const history = useHistory();
  const { pathname, search } = useLocation();
  const { data: tenant } = useSWR('tenant-name', getTenantName);

  useLayoutEffect(() => {
    if (!tenant) {
      return;
    }

    const pathIsContractor = isContractorPath(pathname);
    const pathIsMobis = isMobisPath(pathname);

    const userIsContractor = tenant === 'contractor';
    const userIsMobis = tenant === 'mobis';
    const userIsInternal = tenant === 'primary';

    let redirectTo: string | null = null;

    if (userIsInternal && (pathIsContractor || pathIsMobis)) {
      const pathWithoutPrefix = pathIsContractor
        ? pathname.replace('/contractor', '')
        : pathname.replace('/mobis', '');
      redirectTo = `${pathWithoutPrefix || '/'}${search}`;
    } else if (userIsContractor && !pathIsContractor) {
      const pathWithoutPrefix = pathIsMobis
        ? pathname.replace('/mobis', '')
        : pathname;
      redirectTo = `/contractor${pathWithoutPrefix}${search}`;
    } else if (userIsMobis && !pathIsMobis) {
      const pathWithoutPrefix = pathIsContractor
        ? pathname.replace('/contractor', '')
        : pathname;
      redirectTo = `/mobis${pathWithoutPrefix}${search}`;
    }

    if (redirectTo && redirectTo !== `${pathname}${search}`) {
      history.replace(redirectTo);
    }
  }, [tenant, pathname, search, history]);

  if (!tenant) {
    return null;
  }

  return (
    <>
      <SecureRoute {...props} />
    </>
  );
};

export const SecureSentryRoute = Sentry.withSentryRouting(OktaRoute);

export const SentryRoute = Sentry.withSentryRouting(Route);
